import { Component } from '@angular/core';
import { Validators } from '@angular/forms';
import { TextInputComponent } from '../../../../../../components/kit/input/text-input/text-input.component';
import { fb } from '../../../../../shared/shared.global-service';
import { BaseDialogComponent } from '../../../../../../components/kit/base-dialog/base-dialog.component';

@Component({
    selector: 'app-paste-pattern-dialog',
    templateUrl: './text-prompt-dialog.component.html',
    imports: [
        TextInputComponent,
    ],
})
export class TextPromptDialogComponent extends BaseDialogComponent {
    form = fb.group({
        text: fb.control<number | null>(null, Validators.required),
    });

    label = 'inputs.title';

    constructor() {
        super();
        if (this.dialogConfig.data?.label) {
            this.label = this.dialogConfig.data.label;
        }
        if (this.dialogConfig.data?.value) {
            this.form.patchValue({ text: this.dialogConfig.data.value });
        }
    }

    override async save() {
        if (this.form.invalid) {
            return;
        }
        this.dialogRef.close(this.form.value.text);
    }
}
